import { Typography } from "@circle-react-uikit/Typography";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import { CheckoutDescription } from "../CheckoutDescription";
import { Column } from "../components/Column";

interface SSOLoginPromptProps {
  className?: string;
}

export const SSOLoginPrompt = ({ className }: SSOLoginPromptProps) => {
  const { currentCommunity, loginRedirectUrl, authProviderProperties } =
    usePaywallCheckoutContext();

  if (!authProviderProperties?.is_sso_authentication_required) {
    return null;
  }

  return (
    <Column
      className={classNames(
        "flex size-full flex-col items-center text-center lg:h-auto lg:items-start",
        className,
      )}
      wrapperClassName="h-full lg:pt-20 flex flex-col items-center"
    >
      <CheckoutDescription.CommunityHeader
        className="lg:invisible lg:block"
        community={currentCommunity}
      />
      <div className="flex h-full items-center justify-center lg:h-auto">
        <div className="flex max-w-[24rem] flex-col gap-y-8">
          {currentCommunity.icon_url && (
            <div className="flex justify-center">
              <img
                loading="lazy"
                className="w-[4rem]"
                src={currentCommunity.icon_url}
                alt=""
              />
            </div>
          )}
          <div className="flex flex-col gap-y-1">
            <Typography.TitleMd>
              {t("paywall_checkout.sso_login_prompt.title")}
            </Typography.TitleMd>
            <Typography.BodyMd color="text-default">
              {t("paywall_checkout.sso_login_prompt.subtitle", {
                community_name: currentCommunity.name,
              })}
            </Typography.BodyMd>
          </div>
          <div className="flex flex-row justify-center">
            <a href={loginRedirectUrl}>
              <Button variant="circle" large>
                {t("paywall_checkout.sso_login_prompt.call_to_action", {
                  auth_provider_name: authProviderProperties.name,
                })}
              </Button>
            </a>
          </div>
          <Typography.LabelXs color="text-default">
            {t("paywall_checkout.sso_login_prompt.note")}
          </Typography.LabelXs>
        </div>
      </div>
    </Column>
  );
};
